import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useCartData } from '../../hooks/order';

const LanguageSync = () => {
  const { i18n } = useTranslation();
  const { spanishLanguagePref } = useCartData();

  useEffect(() => {
    i18n.changeLanguage(spanishLanguagePref ? 'es' : 'en');
  }, [spanishLanguagePref, i18n]);

  return null;
};

export default LanguageSync;
